import firebase from "firebase/app";
import "firebase/functions";

export default {
  activatePharmacy: function(pharmacy_id) {
    console.log(pharmacy_id);
    var fn = firebase.functions().httpsCallable("activatePharmacy");
    return new Promise(resolve => {
      fn().then(resolve());
    });
  }
};
